import { FlaskConical } from 'lucide-react';

import { BADGE_BASE_CLASS, BADGE_VARIANT_CLASS, HIGHLIGHTED_EXPERIMENTS } from './VariantBadge.constants';
import type { VariantBadgeProps } from './VariantBadge.types';

export const VariantBadge = ({ experiment, variant, className = '' }: VariantBadgeProps) => {
	const tone = HIGHLIGHTED_EXPERIMENTS.has(experiment) ? 'highlighted' : 'neutral';

	return (
		<span className={`${BADGE_BASE_CLASS} ${BADGE_VARIANT_CLASS[tone]} ${className}`} title={experiment}>
			<FlaskConical className="h-[12px] w-[12px]" />
			<span className="font-mono">{`${experiment} · ${variant}`}</span>
		</span>
	);
};
